import React, {Component} from 'react';
import {DetailListWrap} from './components';
import PropTypes from 'prop-types';

class DetailList extends Component {
  render() {
    return(
      <DetailListWrap>
        {this.props.children}
      </DetailListWrap>
    )
  }
}

DetailList.propTypes = {
  children: PropTypes.node
}


export default DetailList;



// WEBPACK FOOTER //
// ./src/system/list/detail.js